module.exports = __webpack_public_path__ + "img/GS_Profile-Tshegofatso Lesejane.18e1af04.png";